import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const CyberSecurity = () => {
  // const homeMenu = [
  //     { label: "Vision", link: "/about" },
  //     {
  //         label: "Management", link: "", subMenu: [
  //             { label: "Director-Principal's Message", link: "/PrincipalMessage" },
  //             { label: "Leadership Team", link: "/leadershipTeam" },
  //             { label: "Patron’s Message", link: "/patrons" },
  //             { label: "Advisory Board", link: "/advisoryBoard" },
  //         ]
  //     },

  //     { label: "International Collaborations", link: "/partnership" },
  //     { label: "Awards & Achievements", link: "/awardsAcheivements" },
  //     { label: "Faculty", link: "/faculty" },
  //     { label: "Staff Details", link: "/staffDetails" },
  //     { label: "School Strength ", link: "/schoolStrength" },
  //     { label: "Gallery", link: "/Gallery", subMenu: [{ label: "Photo Gallery", link: "/Gallery" }, { label: "Video Gallery", link: "/VideoGallery" },] },

  // ]
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-cyber.jpg" />
      {/* <Menu MenuItem={homeMenu} /> */}
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Cyber@Lotusमित्र"
                breadEnd="Cyber@Lotusमित्र"
                breadMid="Cyber@Lotusमित्र"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12 mb-4">
              <div class="lab-heading mb-4">
                <div class="lab-btn" id="mb-lab-btn">
                  <span>Cyber@Lotusमित्र</span>
                </div>
                <ul class="labs-list">
                  <li>
                    <a class="inc-tlink-active" href="/CyberSecurity">
                      Activities{" "}
                    </a>
                  </li>
                  <li>
                    <a class="" href="/Videos">
                      Videos
                    </a>
                  </li>
                  <li>
                    <a class="" href="/StoryBooks">
                      E-Cyber Story Books
                    </a>
                  </li>
                </ul>
              </div>
              {/* <h4 className="color-red text-center"> Cyber@Lotusमित्र  </h4> */}

              <div class="accordion cyber_page" id="accordionExample">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="heading9">
                    <button
                      class="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse9"
                      aria-expanded="true"
                      aria-controls="collapse9"
                    >
                      AI Fools Week <span>(30th March to 4th April 2026)</span>
                    </button>
                  </h2>
                  <div
                    id="collapse9"
                    class="accordion-collapse collapse show"
                    aria-labelledby="heading9"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body">
                      <div className="row sports">
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools1.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools1.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools2.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools2.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools3.JPG"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools3.JPG"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools4.JPG"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools4.JPG"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools5.png"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools5.png"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools6.JPG"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools6.JPG"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools7.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools7.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools8.jpeg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools8.jpeg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools9.jpeg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools9.jpeg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools10.jpeg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools10.jpeg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools11.jpeg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools11.jpeg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools12.jpeg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools12.jpeg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools13.jpeg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools13.jpeg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools14.jpeg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/AI-Fools14.jpeg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="heading9">
                    <button
                      class="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse9"
                      aria-expanded="true"
                      aria-controls="collapse9"
                    >
                      October – National Cybersecurity Awareness Month 2025
                    </button>
                  </h2>
                  <div
                    id="collapse9"
                    class="accordion-collapse collapse"
                    aria-labelledby="heading9"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body">
                      <div className="row sports">
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/1.png"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/1.png"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/2.png"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/2.png"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/3.png"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/3.png"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/4.png"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/4.png"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/5.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/5.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/6.png"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/6.png"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/7.png"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/7.png"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/8.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/8.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/18.png"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/18.png"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/9.png"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/9.png"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/10.png"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/10.png"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/11.png"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/11.png"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/12.png"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/12.png"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/13.png"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/13.png"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/14.png"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/14.png"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/15.png"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/15.png"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/16.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/16.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/17.png"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/17.png"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="heading6">
                    <button
                      class="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse6"
                      aria-expanded="true"
                      aria-controls="collapse6"
                    >
                      Cyber Chetna – Cyber Security Workshop at LVIS Gurugram
                    </button>
                  </h2>
                  <div
                    id="collapse6"
                    class="accordion-collapse collapse "
                    aria-labelledby="heading6"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body">
                      <div className="row sports">
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_1.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_1.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_2.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_2.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_3.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_3.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_4.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_4.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_5.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_5.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_6.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_6.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_7.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_7.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_8.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_8.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_9.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_9.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_10.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/Cyber_Chetna_10.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />{" "}
                            <p> </p>{" "}
                          </a>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingfive">
                    <button
                      class="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapsefive"
                      aria-expanded="true"
                      aria-controls="collapsefive"
                    >
                      Awareness Drive for Grade 6 Learners{" "}
                      <span>( Sat, 21 July 2025 )</span>
                    </button>
                  </h2>
                  <div
                    id="collapsefive"
                    class="accordion-collapse collapse"
                    aria-labelledby="headingfive"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body">
                      <div className="row sports">
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-1.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-1.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-2.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-2.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-3.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-3.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-4.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-4.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-5.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-5.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-6.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-6.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-7.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-7.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-8.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-8.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-9.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-9.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-10.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-10.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-11.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness-6-11.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingfour">
                    <button
                      class="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapsefour"
                      aria-expanded="true"
                      aria-controls="collapsefour"
                    >
                      Awareness Workshop for Parents{" "}
                      <span>( Sat, 17th May 2025 )</span>
                    </button>
                  </h2>
                  <div
                    id="collapsefour"
                    class="accordion-collapse collapse"
                    aria-labelledby="headingfour"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body">
                      <div className="row sports">
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness1.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness1.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness2.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness2.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness3.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness3.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness4.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness4.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness5.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness5.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness6.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness6.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness7.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness7.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness8.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber-awareness8.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingOne">
                    <button
                      class="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      Cyber Security Awareness Week Grades X & XII{" "}
                      <span>( March 24 to 28, 2025 )</span>
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    class="accordion-collapse collapse"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body">
                      {/* <p>Lotus Valley International school organized a Cyber Security Awareness Week from March 24 to 28, 2025, underthe banner of Cyber Security Club – Cyber@Lotus मित्र to raise awareness about responsible internet use andonline safety.</p>
                                            <p>With the rapid expansion of the digital world, it is more important than ever for students to be aware of cyberhygiene and the risks associated with online threats. As young users are increasingly vulnerable to cybercrimes,awareness and education play a key role in ensuring online safety. Keeping this in mind, various activities wereconducted for senior grades to promote a safer and more responsible digital experience.</p>
                                            <p>The week started with an insightful RJ Radio session, which enlightened the learners of maintaining a cyber-safeenvironment within our school community. The week featured a variety of engaging activities such as PosterMaking, Slogan Writing, and video making that encouraged students to express their thoughts creatively on cybersecurity. Students participated actively and asked thought-provoking questions, making the activities highlyinteractive and engaging. The event was a resounding success, empowering students with vital knowledge tobecome responsible digital citizens.</p>
                                            <p>Learners' work was showcased on the school's digital platforms, spreading awareness among both studentsand teachers.</p>
                                            <p> The Cyber Security Club – Cyber@Lotusमित्र remains committed to promoting a culture of safe and responsibleinternet usage, ensuring continued awareness and education in the future.</p> */}
                      <div className="row sports">
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber1.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber1.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber2.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber2.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber3.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber3.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber4.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber4.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber5.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber5.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber6.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber6.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber7.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber7.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber8.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber8.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber9.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/cyber9.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingTwo">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      GRADES IV & V<span>(JULY 2025-26 )</span>
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    class="accordion-collapse collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body">
                      {/* <p>       As part of our Cyber Safety Week, Learners of Grade IV and Grade V participated in exciting and educational activities focused on learning how to stay safe online.</p> */}
                      <p>
                        <strong>Grade IV: "Be Cyber Smart"</strong>
                      </p>
                      {/* <p>Grade IV learners explored the basics of safe internet practices through the activity "Be Cyber Smart."</p>
                                            <p>Learners were taught:</p>
                                            <ul>
                                                <li> The importance of not sharing personal information online</li>

                                                <li> Recognizing safe and unsafe websites</li>

                                                <li> Reporting anything suspicious to a trusted adult</li>
                                            </ul>
                                            <p>The students enthusiastically engaged with the Activity, asked thoughtful questions, and showcased their understanding through colorful posters.</p> */}
                      <div className="row sports">
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade4-july1.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade4-july1.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade4-july2.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade4-july2.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade4-july3.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade4-july3.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                      </div>

                      <p>
                        {" "}
                        <strong>
                          Grade V: "Cyber Heroes – Create a Strong Password"
                        </strong>
                      </p>
                      {/* <p>learners stepped into the role of Cyber Heroes to learn the value of creating and protecting strong passwords.</p>
                                            <p>They learned:</p>
                                            <ul>
                                                <li>What makes a strong password?</li>
                                                <li>Why passwords should be kept secret?</li>
                                                <li>How to use symbols, numbers, and upper/lowercase letters?</li>
                                            </ul>
                                            <p>The activity helped Learners understand the power of secure passwords and how they are the first line of defense in staying safe online.</p> */}
                      <div className="row sports">
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade5-july1.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade5-july1.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade5-july2.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade5-july2.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="headingThree">
                    <button
                      class="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      DESIGN THINKING ACTIVITY (GRADES VII- IX)
                      <span>( JULY 2025-26 )</span>
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    class="accordion-collapse collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample"
                  >
                    <div class="accordion-body">
                      {/* <p>In the month of July, students from Grades VII to IX actively participated in Design Thinking-based activities integrated with computer applications. Grades VII and VIII learners explored the theme "Tech for Good – Digital Reuse and Sustainability." They reflected on how outdated technology, such as unused apps or old devices, impacts daily life and the environment. Using the Design Thinking framework, students identified specific problems and collaboratively brainstormed digital solutions. Their projects included ideas like creating a digital planner for decluttering, repurposing old phones, and designing awareness posters.</p>
                                            <p>Grade IX students took on a more advanced project titled "AI-Based Solution to a Challenge Faced in School." They identified school-related issues—such as lost items or noisy environments—and proposed innovative AI-based solutions using image recognition, sensors, or chatbots. The final output was a visually appealing poster that demonstrated each step of the Design Thinking process, along with sketches and feedback. The activities promoted problem-solving, creativity, and digital skill-building across the learners. </p> */}
                      <div className="row sports">
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade7-july1.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade7-july1.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade7-july2.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade7-july2.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade7-july3.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade7-july3.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade7-july4.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade7-july4.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade7-july5.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade7-july5.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>

                        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade7-july6.jpg"
                          >
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/grade7-july6.jpg"
                              className="img-fluid"
                              alt="LOtusVAlley"
                            />
                            <p> </p>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default CyberSecurity;
